module.exports = __webpack_public_path__ + "img/info.8f4f1223.svg";